import React from 'react'
import PropTypes from 'prop-types'

import { optionListItemStyle } from '../styles'

const OptionListItemButton = ({ id, isSelected, onClick, label }) => (
  <li key={id} style={optionListItemStyle}>
    <a
      href=""
      className={`btn btn-${isSelected ? 'info' : 'default'}`}
      onClick={(e) => onClick(e, id)}>
      {label}
    </a>
  </li>);

OptionListItemButton.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
}

export default OptionListItemButton


// WEBPACK FOOTER //
// ./src/Components/checkout/components/OptionList/OptionListItemButton.jsx